module.exports = __webpack_public_path__ + "img/gear.4d1ec08c.svg";